import classNames from 'classnames';
import React, { useState, useEffect } from 'react';
import { useForm } from "react-hook-form";
import useAccount from "hooks/useAccount";
import { useRecoilValueLoadable, useRecoilValue } from 'recoil';
import lookupCountryAtom from 'recoil/lookup/country';
import lookupCurrencyAtom from 'recoil/lookup/currency';
import validationSchema from 'utils/validationSchemas/paymentInfo';
import { yupResolver } from '@hookform/resolvers/yup';
import ButtonWithSpinner from './buttons/ButtonSpinner';
import useLookup from 'hooks/useLookup';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faInfoCircle, faTable, faChartArea } from "@fortawesome/free-solid-svg-icons";
import ConfirmPopup from 'components/modals/ConfirmPopup';
import TCPopup from 'components/modals/T&CPopup';
import PayOutChartPerLeadProgram from './modals/PayOutChartPerLeadProgramPopup';
import PayOutChartPercentageProgram from './modals/PayOutChartPctProgramPopup';
import useDisplayModal from '../hooks/useDisplayModal';

const RegStepTwo = (props) => {
    const lookupProvider = useLookup();
    const  {affiliatePrograms} = lookupProvider;
    const {handlers, display, clx} = props;
    const {saveText="Save", showHeading=true} = display;
    const {postUpdatePaymentInfo} = handlers;
    const accountProvider = useAccount();
    const { paymentInfo, bankDetails } = accountProvider;
    const { AffiliatePaymentTypeID, Paypal, Wise, PaymentID, ProgramID } = paymentInfo;

    const {
        BankName,
        AccountName,
        AccountNumber,  //for au
        BSBNumber,  //for au
        SwiftCode,  //for intl
        IBAN,  //for intl
        Currency,
        CountryID,
        BankAddress //for intl
    } = bankDetails;

    const [countryList, setCountryList] = useState([]);
    const countryListLoadable = useRecoilValueLoadable(lookupCountryAtom); //todo: put this in uselookup
    const topCountries = [1, 72, 213, 2, 34];
    const currencyList = useRecoilValue(lookupCurrencyAtom);
    const { state: countryListState, contents: countryListContent } = countryListLoadable;

    useEffect(() => {
        switch (countryListState) {
            case "hasValue":
                setCountryList(countryListContent);
                break;
            case "hasError":
                // toast.error("Failed to load club's category", catsContent);
                break;
            case "loading":

                break;
            default:

                break;

        }
    }, [countryListState, countryListContent]) // eslint-disable-line react-hooks/exhaustive-deps
    
    const {
        handleSubmit,
        //trigger,
        formState: { errors, isValid, isSubmitted },
        register,
        watch,
        setValue
        
    } = useForm({
        mode: "all",
        defaultValues: {
            paymentType: AffiliatePaymentTypeID,
            paypal: Paypal,
            wise: Wise,
            payID: PaymentID,
            countryID: CountryID,
            currency: Currency,
            bankName: BankName,
            bankAddress: BankAddress,
            accountName: AccountName,
            accountNumber: AccountNumber,
            bsb: BSBNumber,
            iban: IBAN,
            swiftCode: SwiftCode,
            programID: affiliatePrograms.find(p=>p.ItemID === ProgramID) ? ProgramID : -1
        },
        resolver: yupResolver(validationSchema)
    });

    const watchPaymentType = watch("paymentType", AffiliatePaymentTypeID);
    const wacthCountryID = watch("countryID", -1);
    const watchCurrency = watch("currency", "");
    const euros = [12,19,21,90,50,59,65,70,52,83,94,100,124,122,123,140,153,169,186,184,63,181,174,166,92,51];
    
    
    useEffect(() => setValue("paymentType", AffiliatePaymentTypeID), [AffiliatePaymentTypeID, setValue]);
    useEffect(() => setValue("paypal", Paypal), [Paypal, setValue]);
    useEffect(() => setValue("wise", Wise), [Wise, setValue]);
    useEffect(() => setValue("payID", PaymentID), [PaymentID, setValue]);
    useEffect(() => setValue("countryID", CountryID), [CountryID, setValue]);
    useEffect(() => {
        if(affiliatePrograms.find(p=>p.ItemID === ProgramID))
            setValue("programID", ProgramID)
    }, [ProgramID, affiliatePrograms, setValue]);
    useEffect(() => setValue("currency", Currency), [Currency, setValue]);
    useEffect(() => setValue("bankName", BankName), [BankName, setValue]);
     useEffect(() => setValue("bankAddress", BankAddress), [BankAddress, setValue]);
    useEffect(() => setValue("accountName", AccountName), [AccountName, setValue]);
    useEffect(() => setValue("accountNumber", AccountNumber), [AccountNumber, setValue]);
    useEffect(() => setValue("bsb", BSBNumber), [BSBNumber, setValue]);
    useEffect(() => setValue("iban", IBAN), [IBAN, setValue]);
    useEffect(() => setValue("swiftCode", SwiftCode), [SwiftCode, setValue]);
        const onCountryChanged = (e)=>{
       
        const cid = parseInt(e.target.value);
       
        if((watchPaymentType === "DirectDeposit" || watchPaymentType === "PayID")  && cid > 1){
            setValue("paymentType", "");
        }

        if (euros.includes(cid)) {
            setValue("currency", "EUR");
        }
        else {
            switch (cid) {

                case 1:
                    setValue("currency", "AUD");
                    break;
                case 2:
                    setValue("currency", "NZD");
                    break;
                case 34:
                    setValue("currency", "CAD");
                    break;
                case 72:
                    setValue("currency", "GBP");
                    break;
                case 213:
                    setValue("currency", "USD");
                    break;
                case 43:
                    setValue("currency", "CNY");
                    break;
                case 182:
                    setValue("currency", "SGD");
                    break;
                case 200:
                    setValue("currency", "THB");
                    break;
                case 88:
                    setValue("currency", "HKD");
                    break;
                case 38:
                case 118:
                    setValue("currency", "CHF");
                    break;
                default:
                    setValue("currency", "");
            }
        }
    }

     

    const { updatePaymentInfo } = accountProvider;

    const onSubmitHandler = async (frmData, e) => {
        e.preventDefault();
        if (updatePaymentInfo.isLoading) return;

        const submittedData = {
            AffiliatePaymentTypeID: frmData.paymentType,
            PaymentID: frmData.payID,
            Paypal: frmData.paypal,
            Wise: frmData.wise,
            BankDetails: {
                BSBNumber: frmData.bsb,
                BankName: frmData.bankName,
                SwiftCode: frmData.swiftCode,
                AccountName: frmData.accountName,
                AccountNumber: frmData.accountNumber,
                IBAN: frmData.iban,
                CountryID: frmData.countryID,
                Currency: frmData.countryID === 1 ? "AUD" : frmData.currency,
                BankAddress: frmData.bankAddress,
            },
            ProgramID: frmData.programID
        }

        updatePaymentInfo.mutateAsync(submittedData)
            .then(() => {
                if (postUpdatePaymentInfo && typeof postUpdatePaymentInfo === "function") {
                    const isNonAu = frmData.countryID != 1;
                    const isBankTransfer = watchPaymentType === "DirectDeposit";
                    const isSkipBilling = (isNonAu && isBankTransfer) == false;
                    postUpdatePaymentInfo(isSkipBilling);
                }
            })
            .catch(() => {}); // error handled by onError in useAccount
    }

    const { open: afPrgmComfirmPopup, handleOpen: openAfPrgmComfirmPopup, handleClose: closeAfPrgmComfirmPopup} = useDisplayModal();
    const { open: showTCPopup, handleOpen: openTCPopup, handleClose: closeTCPopup} = useDisplayModal();
    const { open: showPctProgramChart, handleOpen: openPctProgramChart, handleClose: closePctProgramChart } = useDisplayModal();
    const { open: showPayLeadProgramChart, handleOpen: openPayLeadProgramChart, handleClose: closePayLeadProgramChart } = useDisplayModal();
    
    return (
        <form className={clx} onSubmit={handleSubmit(onSubmitHandler)}>
            <div className="step two">
                {showHeading && <h2>How would you like to get paid?</h2>}


                { 
                    (parseInt(ProgramID) > 0) && affiliatePrograms.find(p=> p.ItemID === ProgramID)
                    ?
                    <div className="af-prgm">
                        <p>Your account is on the {affiliatePrograms.find(p=> parseInt(p.ItemID) === parseInt(ProgramID)).ItemName} program <span className="info" onClick={()=>openAfPrgmComfirmPopup()} style={{cursor: "pointer"}} ><FontAwesomeIcon icon={faInfoCircle} /></span></p>
                        <ConfirmPopup open={afPrgmComfirmPopup} 
                            close={closeAfPrgmComfirmPopup}
                            confirm={closeAfPrgmComfirmPopup}
                            heading={"Your account is on the <br/>" + affiliatePrograms.find(p=> parseInt(p.ItemID) === parseInt(ProgramID)).ItemName + " program"}
                            btnText="Ok, got it">
                                {
                                    ProgramID === 10 
                                    ?
                                     <p>
                                        You will get 50% share of any purchases made from the people you send to our platform.
                                        {/* <span onClick={e=>{e.preventDefault(); openPctProgramChart()}} style={{cursor: "pointer"}}><FontAwesomeIcon icon={faChartArea} title="View Payout Chart" /></span> */}
                                     </p>
                                    : ProgramID === 12 
                                        ?
                                        <p>You will get $3 for each person that you send to our platform and they complete the registration form. 
                                        {/* <span onClick={e=>{e.preventDefault(); openPayLeadProgramChart()}} style={{cursor: "pointer"}}><FontAwesomeIcon icon={faChartArea}  title="View Payout Chart"/></span> */}
                                        </p>
                                        : 
                                         <p>You will get $10 for each person that you send to our platform and they make a purchase.</p> 

                                }
                                <p>There are a few rules that apply, so please read the <a href="/" onClick={e=>{e.preventDefault();openTCPopup()}} title="Click to find out more">Terms &amp; conditions</a>.</p>
                                {/* <p>If you'd like to subscribe to a different program, you'll need to create a new account.</p> */}
                                <TCPopup open={showTCPopup} close={closeTCPopup} />
                        </ConfirmPopup>
                    </div>
                    :<fieldset className={classNames("input", { error: errors?.programID?.message })}>
                        <h3>Select your affiliate program</h3>
                        <div className={classNames("radio-group", { error: errors?.programID?.message })}>
                            {
                                affiliatePrograms.map((program, i)=>
                                    <p className="revenue" key={`prg_${i}`}>
                                        <span className="radio">
                                            <input type="radio" id={`program_${i}`} name={`program_${i}`} value={program.ItemID} {...register("programID")} />
                                            <label htmlFor={`program_${i}`}>
                                                {program.ItemName}
                                            </label>
                                           
                                        </span>
                                        { program.ItemID == 10 && <>&nbsp;<span onClick={e=>{e.preventDefault(); openPctProgramChart()}} style={{cursor: "pointer"}}><FontAwesomeIcon icon={faChartArea} title="View Payout Chart" /></span></>}
                                        { program.ItemID == 12 &&  <>&nbsp;<span onClick={e=>{e.preventDefault(); openPayLeadProgramChart()}} style={{cursor: "pointer"}}><FontAwesomeIcon icon={faChartArea}  title="View Payout Chart"/></span></>}
                                    </p>
                                )
                            }
                            {errors?.programID?.message && <span className="error-msg">{errors?.programID?.message}</span>}
                            
                        </div>
                    </fieldset>
                }
                <PayOutChartPerLeadProgram open={showPayLeadProgramChart} close={closePayLeadProgramChart} />
                <PayOutChartPercentageProgram open={showPctProgramChart} close={closePctProgramChart} />

                <div className='fieldset-group'>
                    <fieldset className="input">
                        {/* <h3>Select Payment Country</h3> */}
                        <p>
                            <span className="country-currency animated-label-input">
                                <label htmlFor="country">Country / Currency</label>
                                <span className='input-row'>
                                    <span className={classNames("country", { error: isSubmitted && errors?.countryID?.message })} >
                                        <span className="select">
                                            <select 
                                                name="country" 
                                                id="country"
                                                value={wacthCountryID}
                                                {...register("countryID")} 
                                                onChange={(e)=>{
                                                    register("countryID").onChange(e);
                                                    //console.log("going in here")
                                                    onCountryChanged(e);
                                                }}
                                                >
                                                    <option disabled={true} value="-1">Please select</option>
                                                {
                                                    countryList
                                                    .filter(itm => topCountries.includes(itm.ItemID))
                                                    .sort((a, b) => a.ItemName > b.ItemName ? 1 : -1)
                                                    .map((country) => (
                                                        <option key={`country_${country.ItemID}`} value={country.ItemID}>{country.ItemName}</option>
                                                    ))
                                                }
                                                <option disabled={true} value={-2}>-------------------------------------</option>
                                                {
                                                    countryList
                                                    .filter(itm => !topCountries.includes(itm.ItemID))
                                                    .sort((a, b) => a.ItemName > b.ItemName ? 1 : -1)
                                                    .map((country) => (
                                                        <option key={`country_${country.ItemID}`} value={country.ItemID}>{country.ItemName}</option>
                                                    ))
                                                }
                                            </select>
                                        </span>
                                        {isSubmitted && errors?.countryID?.message && <span className="error-msg">{errors?.countryID?.message}</span>}
                                    </span>
                                    <span className={classNames("currency")} >
                                        <span className="select">
                                            <select name="currency" id="currency"
                                                value={watchCurrency}
                                                {...register("currency")} >
                                                {
                                                    currencyList.map((currency) => (
                                                        <option key={currency} value={currency}>{currency}</option>
                                                    ))
                                                }
                                            </select>
                                        </span>
                                    </span>
                                </span>
                                
                            </span>
                        </p>
                        <div>

                        </div>

                        
                    </fieldset>
                    <fieldset className="input">
                        <h3>Select payment method</h3>
                        <div className="radio-group">
                            <p className="paypal input">
                                <span className="radio">
                                    <input type="radio" id="paypal" value="PayPal"
                                        {...register("paymentType")}
                                    /><label htmlFor="paypal">PayPal (Recommended)</label>
                                </span>
                                {
                                    watchPaymentType === "PayPal" &&
                                    <span className={classNames("input", "animated-label-input", { error: isSubmitted && errors?.paypal?.message })}>

                                       
                                        <label htmlFor="paypal-acc">PayPal details</label>
                                        <input id="paypal-acc" type="text"
                                            placeholder=" "
                                            {...register("paypal")}
                                        />
                                        {isSubmitted && errors?.paypal?.message && <span className="error-msg">{errors?.paypal?.message}</span>}
                                    
                                        
                                    </span>
                                }

                            </p>

                            <p className="paypal input">
                                <span className="radio">
                                    <input type="radio" id="wise" value="Wise"
                                        {...register("paymentType")}
                                    /><label htmlFor="wise">Wise</label>
                                </span>
                                {
                                    watchPaymentType === "Wise" &&
                                    <span className={classNames("input", "animated-label-input", { error: isSubmitted && errors?.wise?.message })}>

                                       
                                        <label htmlFor="paypal-acc">Wise details</label>
                                        <input id="paypal-acc" type="text"
                                            placeholder=" "
                                            {...register("wise")}
                                        />
                                        {isSubmitted && errors?.wise?.message && <span className="error-msg">{errors?.wise?.message}</span>}
                                    
                                        
                                    </span>
                                }

                            </p>
                            
                            {
                                wacthCountryID && parseInt(wacthCountryID) === 1 && 
                                <p className="payid input">
                                <span className="radio">
                                    <input type="radio" id="payid" name="payid" value="PayID"
                                        {...register("paymentType")} /><label htmlFor="payid">PayID</label>

                                </span>
                                {
                                    watchPaymentType === "PayID" &&
                                    <span className={classNames("input", "animated-label-input", { error: errors?.payID?.message })}>
                                        <label htmlFor="payid-no">PayID number</label>
                                        <input id="payid-no" type="text" placeholder=" " {...register("payID")} />
                                        {errors?.payID?.message && <span className="error-msg">{errors?.payID?.message}</span>}
                                    </span>
                                }

                                </p>
                            }

                            {
                                wacthCountryID && parseInt(wacthCountryID) === 1
                                &&
                                <p className="bank-transfor">
                                    <span className="radio">
                                        <input type="radio" id="bank-transfor" name="bank-transfor"
                                            value="DirectDeposit" {...register("paymentType")}
                                        /><label htmlFor="bank-transfor">Bank Transfer</label>
                                    </span>

                                    {
                                        watchPaymentType === "DirectDeposit" &&
                                        <span className="bank-detail input">


                                            {/* {
                                                wacthCountryID > 1 &&
                                                <span className="input">
                                                    <span className={classNames("currency", { error: errors?.currency?.message })} >
                                                        <label htmlFor="currency" >Currency</label>
                                                        <span className="select">
                                                            <select name="currency" id="currency"
                                                                value={watchCurrency}
                                                                {...register("currency")} >
                                                                {
                                                                    currencyList.map((currency) => (
                                                                        <option key={currency} value={currency}>{currency}</option>
                                                                    ))
                                                                }
                                                            </select>
                                                        </span>
                                                        {errors?.countryID?.message && <span className="error-msg">{errors?.countryID?.message}</span>}
                                                    </span>
                                                </span>
                                            } */}


                                            <span className={classNames("input", "animated-label-input", { error: isSubmitted && errors?.bankName?.message })}>
                                                <label htmlFor="f-inst">Financial institution name</label>
                                                <input id="f-inst" type="text" placeholder=" "
                                                    {...register("bankName")}
                                                />
                                                {isSubmitted && errors?.bankName?.message && <span className="error-msg">{errors?.bankName?.message}</span>}
                                            </span>

                                            {
                                                wacthCountryID > 1 &&
                                                <span className={classNames("input", "animated-label-input", { error: isSubmitted &&errors?.bankAddress?.message })}>
                                                    <label htmlFor="f-inst">Financial institution address</label>
                                                    <input id="f-inst" type="text" placeholder=" "
                                                        {...register("bankAddress")}
                                                    />
                                                    {isSubmitted && errors?.bankAddress?.message && <span className="error-msg">{errors?.bankAddress?.message}</span>}
                                                </span>
                                            }

                                            <span className={classNames("input", "animated-label-input", { error: isSubmitted && errors?.accountName?.message })}>
                                                <label htmlFor="acc-name">Account name</label>
                                                <input id="acc-name" type="text" placeholder=" "
                                                    {...register("accountName")}
                                                />
                                                {isSubmitted && errors?.accountName?.message && <span className="error-msg">{errors?.accountName?.message}</span>}
                                            </span>
                                            {
                                                wacthCountryID > 1 &&
                                                <>
                                                    <span className={classNames("input", "animated-label-input", { error: isSubmitted && errors?.swiftCode?.message })}>
                                                        <label htmlFor="bsb-no">BIC/SWIFT</label>
                                                        <input id="bsb-no" type="text" placeholder=" "
                                                            {...register("swiftCode")} />
                                                        {isSubmitted && errors?.swiftCode?.message && <span className="error-msg">{errors?.swiftCode?.message}</span>}
                                                    </span>

                                                    <span className={classNames("input", "animated-label-input", { error: isSubmitted && errors?.iban?.message })}>
                                                        <label htmlFor="acc-no">IBAN</label>
                                                        <input id="acc-no" type="text" placeholder=" "
                                                            {...register("iban")}
                                                        />
                                                        {isSubmitted && errors?.iban?.message && <span className="error-msg">{errors?.iban?.message}</span>}
                                                    </span>
                                                </>
                                            }

                                            {
                                                wacthCountryID && parseInt(wacthCountryID) === 1 &&
                                                <>
                                                    <span className={classNames("input", "animated-label-input", { error: isSubmitted && errors?.bsb?.message })}>
                                                        <label htmlFor="bsb-no">BSB Number</label>
                                                        <input id="bsb-no" type="text" placeholder=" "
                                                            {...register("bsb")} />
                                                        {isSubmitted && errors?.bsb?.message && <span className="error-msg">{errors?.bsb?.message}</span>}
                                                    </span>

                                                    <span className={classNames("input", "animated-label-input", { error: isSubmitted && errors?.accountNumber?.message })}>
                                                        <label htmlFor="acc-no">Account Number</label>
                                                        <input id="acc-no" type="text" placeholder=" "
                                                            {...register("accountNumber")}
                                                        />
                                                        {isSubmitted && errors?.accountNumber?.message && <span className="error-msg">{errors?.accountNumber?.message}</span>}
                                                    </span>
                                                </>
                                            }
                                        </span>
                                    }
                                </p>
                            }


                            
                            <p className="error-msg">Please select option</p>
                        </div>
                    </fieldset>
                    <fieldset className="submit">
                        <p className="btn grey link">
                            <ButtonWithSpinner
                                className={classNames("", { "disabled": !isValid })}
                                text={saveText} isLoading={updatePaymentInfo.isLoading} 
                                //disabled={!isValid} 
                            />
                        </p>
                    </fieldset>
                </div>

            </div>

        </form>

    );

}

export default RegStepTwo;